export const fontFamily = '\'Press Start 2P\', system-ui';

export const worldTypes = {
  craterRun: 'CraterRun',
  spaceport: 'Spaceport',
  soloDressingRoom: 'SoloDressingRoom',
};

const worldTypeAccentColors = {
  [worldTypes.craterRun]: 'cyan',
  [worldTypes.spaceport]: '#FFD300',
  [worldTypes.soloDressingRoom]: 'lightgrey',
};

export const getWorldTypeAccentColor = (world) => (
  worldTypeAccentColors[world?.rules?.worldType] || worldTypeAccentColors[worldTypes.spaceport]
);

export const hiddenScrollbarStyles = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export const newCraterRunRoomName = 'New Race Room';
export const newSpaceportRoomName = 'New Spaceport';
